import { type Enum } from '@webapp/infrastructure/types/Enum'

export const OrderDraftItemMutationStatuses = {
  CREATING: 'creating',
  FAILED_TO_CREATE: 'failed-to-create',
  UPDATING: 'updating',
  FAILED_TO_UPDATE: 'failed-to-update',
  COMPLETED: 'completed',
} as const

export type OrderDraftItemMutationStatusEnum = Enum<
  typeof OrderDraftItemMutationStatuses
>
